export default __webpack_public_path__ + "static/media/dewali_bg.2657a720.png";